import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { UserInfo } from '../types';

interface AuthState {
  user: UserInfo | null;
  token: string | null;
  isLoggedIn: boolean;
  login: (user: UserInfo) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isLoggedIn: false,
      login: (user: UserInfo) => set({ user, token: user.token, isLoggedIn: true }),
      logout: () => set({ user: null, token: null, isLoggedIn: false }),
    }),
    { name: 'cmp-auth' }
  )
);
